import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Player, ReferralBonus} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";
import {TabName} from "@/services/shop-service";
import {CampaignWheelPanel} from "@/scenes.ui/campaign-wheel-panel";
import SoundUtils from "@/utils/sound-utils";

export class ReferralRewardPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, referralBonus:ReferralBonus, player: Player, takeCallback: () => unknown) {
        super(scene, canvas, referralBonus.startBonus? Tr('ref.welcome.header').toUpperCase() : Tr('ref.bonus.header').toUpperCase());
        this.xButton.setVisible(false);

        let shift =  0;
        let infoText = TextUtils.addTextByFamily(scene,
            referralBonus.startBonus? Tr('ref.welcome.info').toUpperCase() : Tr('ref.bonus.info').toUpperCase(),
            0, -180 - shift, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let improveLabel = TextUtils.addTextAdvanced(scene, referralBonus.startBonus? Tr('ref.welcome.label') : Tr('ref.bonus.label'), 0, -125 - shift * 2,
            '#ffffff', 13, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let awardIcon = SpriteUtils.addSprite(this.scene, 0, -60 - shift * 3, Keys.IC_100_MITHRIL);

        let awardComment = TextUtils.addTextByFamily(this.scene, String(referralBonus.startBonus > 0? referralBonus.startBonus : referralBonus.refBonus) +
            TextUtils.chooseWord(player.todayAward, Tr('izumrud'), Tr('izumruda'), Tr('izumrudov')),
            0, -10 - shift * 4, '#ffffff', 14, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let clanAwardComment = TextUtils.addTextAdvanced(scene, Tr('ref.bonus.comment') +  " " + String(referralBonus.refClanBonus) +
            TextUtils.chooseWord(player.tomorrowAward, Tr('izumrud'), Tr('izumruda'), Tr('izumrudov')), 0, 45 - shift * 5,
            '#babab7', 12, 'normal', 390, 'center', 2, Fonts.ARIAL_MT);
        clanAwardComment.setVisible(referralBonus.refClanBonus > 0 && !!player.clanId);

        this.add([infoText, awardIcon, awardComment, improveLabel, clanAwardComment]);

        this.addCustomButton(0, 150 + shift * 2, Tr('prinjat'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
            takeCallback();
        });
    }

}
